import { Box, Grid } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from 'app/entities/truck-implement/truck-implement.reducer';
import TruckImplementJourneyMap from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-journey-tab/TruckImplementJourneyMap';
import { ILastPosition, IPosition, IRouteInfo } from 'app/modules/dashboards/dashboard-truck-implement/interface/dashboardTruckImplementInterface';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import React, { useCallback, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getInfoRoutesByTruckImplement } from '../../DashboardTruckImplement.reducer';
// import { useBetaVersion } from 'app/modules/dashboards/shared/BetaVersionContext';

export const TruckImplementJourney = (props: RouteComponentProps<{ url: string; id: string }> | any) => {
  const dispatch = useAppDispatch();
  const routeProps = props?.props ?? props;
  const implementId = routeProps.match.params.id;
  const truckImplement = useAppSelector(state => state.truckImplement.entity);
  const loading = useAppSelector(state => state.dashboardTruckImplement.loading);
  const infoRoutesTruckImplement = useAppSelector(state => state.dashboardTruckImplement.infoRoutesTruckImplement);
  const [initialPosition] = useState<IPosition>({ lat: -14.499173, lng: -51.445122 });
  const [center, setCenter] = useState<IPosition>(initialPosition);
  const [lastPosition, setLastPosition] = useState<ILastPosition>(null);
  const [dateEnd, setDateEnd] = useState<string | null>(convertDateTimeFromServer(Date.now()));
  const [dateStart, setDateStart] = useState<string | null>(null);
  const [periodType, setPeriodType] = useState(PeriodicType.TODAY);
  const [positions, setPositions] = useState<IPosition[]>();
  const [routes, setRoutes] = useState<IRouteInfo>();
  const [zoom, setZoom] = useState<number>(4);
  const [isPeriodicCustom, setIsPeriodicCustom] = useState<boolean>(false);
  // const { isBetaVersion } = useBetaVersion();
  const isBetaVersion = false;

  useEffect(() => {
    dispatch(getEntity(implementId));
  }, [dispatch, implementId]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (periodType === PeriodicType.TODAY && zoom === 4) {
        getInfoRoutes();
      }
    }, 300000); // 5 min
    return () => clearInterval(interval);
  }, [periodType, zoom]);

  const sendSensorDataByImplementIdAndPeriodic = (period: PeriodicType) => {
    setPeriodType(period);
  };

  const sendSensorDataByImplement = values => {
    values.preventDefault();
    setIsPeriodicCustom(false);
    getCustomInfoRoutes();
  };

  const changeToCustomPeriodic = () => {
    setPeriodType(PeriodicType.CUSTOM);
    setIsPeriodicCustom(true);
  };

  const getInfoRoutes = useCallback(() => {
    if (periodType === PeriodicType.CUSTOM) return;

    dispatch(getInfoRoutesByTruckImplement({ truckImplementId: implementId, periodicType: periodType, isBetaVersion }));
    setDateStart(null);
    setDateEnd(convertDateTimeFromServer(Date.now()));
  }, [periodType, isBetaVersion]);

  const getCustomInfoRoutes = () => {
    if (periodType === PeriodicType.CUSTOM && dateStart && dateEnd) {
      dispatch(
        getInfoRoutesByTruckImplement({
          truckImplementId: implementId,
          dateStartPeriodic: new Date(dateStart).toISOString(),
          dateEndPeriodic: new Date(dateEnd).toISOString(),
          isBetaVersion,
        })
      );
    }
  };

  useEffect(() => {
    getInfoRoutes();
  }, [getInfoRoutes]);

  useEffect(() => {
    setRoutes(infoRoutesTruckImplement.routes);
    setPositions(infoRoutesTruckImplement.positions);
    setLastPosition(infoRoutesTruckImplement.lastPosition);
  }, [infoRoutesTruckImplement]);

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', paddingTop: '16px', textAlign: 'center', padding: '24px', position: 'relative' }}>
      <PageHeader
        headingId={'journey-heading'}
        headingDataCy={'journeyHeading'}
        contentKey={'fleetSenseApp.vehiclePosition.journey'}
        showButton={false}
        showTruckDetail={true}
        truckDetailProps={props}
        onBetaVersion={true}
        loading={loading}
        onBackClick={() => props.history.replace(`/dashboards/truck-implement/${props.match.params.id}`)}
      />
      <PageFilters
        periodicType={periodType}
        sendSensorDataByImplementIdAndPeriodic={sendSensorDataByImplementIdAndPeriodic}
        changeToCustomPeriodic={changeToCustomPeriodic}
        isCompany={false}
        loading={loading}
        sendSensorDataByImplement={sendSensorDataByImplement}
        dateStart={dateStart}
        setDateStart={setDateStart}
        dateEnd={dateEnd}
        setDateEnd={setDateEnd}
        isOpen={isPeriodicCustom}
        toggle={() => setIsPeriodicCustom(!isPeriodicCustom)}
        showFilters={['periodic']}
        isPeriodAbsolute
      />
      <Grid container>
        <Grid item xs={12}>
          <TruckImplementJourneyMap
            periodType={periodType}
            markerList={lastPosition}
            center={center}
            zoom={zoom}
            setZoom={setZoom}
            loading={loading}
            lastPosition={lastPosition}
            routes={routes}
            positions={positions}
            implementId={implementId}
            licensePlate={truckImplement?.licensePlate}
            setCenter={setCenter}
            initialPosition={initialPosition}
            isBetaVersion={isBetaVersion}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
